import { render, staticRenderFns } from "./sport_competition_result_declined.vue?vue&type=template&id=203ce77c&scoped=true&"
import script from "./sport_competition_result_declined.vue?vue&type=script&lang=js&"
export * from "./sport_competition_result_declined.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "203ce77c",
  null
  
)

export default component.exports